// app/javascript/controllers/dae20/filters_rows_controller.js
// Stimulus-контроллер для динамических строк фильтров (key/value pairs)
// в конструкторе Read Mapping полей ItemTemplate.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row"]

  addRow() {
    const rows = this.rowTargets
    if (rows.length === 0) return

    const lastRow = rows[rows.length - 1]
    const newRow = lastRow.cloneNode(true)

    // Очищаем значения inputs в клонированной строке
    newRow.querySelectorAll('input').forEach(input => { input.value = '' })

    // Вставляем перед кнопкой "+ Добавить фильтр" (блок .flex.items-center),
    // или в конец контейнера
    const addButtonBlock = this.containerTarget.querySelector('.flex.items-center.justify-between')
    if (addButtonBlock) {
      addButtonBlock.before(newRow)
    } else {
      this.containerTarget.appendChild(newRow)
    }
  }

  removeRow(event) {
    // Не удаляем последнюю строку — оставляем хотя бы одну
    if (this.rowTargets.length <= 1) return

    const row = event.target.closest('[data-dae20--filters-rows-target="row"]')
    if (row) row.remove()
  }
}
